import { Component } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { PushPipe } from '@ngrx/component';
import {
    WdxButtonModule,
    WdxButtonSize,
    WdxButtonStyle,
} from '@wdx/shared/components/wdx-button';
import { WdxDropdownModule } from '@wdx/shared/components/wdx-dropdown';
import { WdxIconModule } from '@wdx/shared/components/wdx-icon';
import { WdxSpinnerModule } from '@wdx/shared/components/wdx-spinner';
import { EntityAction, TranslateTokenisedStringPipe } from '@wdx/shared/utils';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Observable } from 'rxjs';

export type ActionRendererAction = EntityAction & {
    callback?: (value: any) => void;
    name?: string;
};

type ActionRendererActionsObs = Observable<ActionRendererAction[]>;

export interface ActionsCellRendererValue {
    actions$: ActionRendererActionsObs;
    defaultCallback: (action: EntityAction, data: any) => void;
}

@Component({
    selector: 'wdx-ag-grid-actions-cell-renderer',

    imports: [
        WdxButtonModule,
        WdxIconModule,
        WdxDropdownModule,
        NgbDropdownModule,
        PushPipe,
        WdxSpinnerModule,
        TranslateTokenisedStringPipe,
    ],
    templateUrl: './actions-cell-renderer.component.html',
    host: { class: 'd-flex h-100 justify-content-center align-items-center' },
})
export class ActionsRendererComponent implements ICellRendererAngularComp {
    public readonly WdxButtonSize = WdxButtonSize;
    public readonly WdxButtonStyle = WdxButtonStyle;
    public actions$?: ActionRendererActionsObs;
    public data: any;
    public opened = false;
    private defaultCallback?: (action: EntityAction, data: any) => void;

    public agInit(
        params: ICellRendererParams<any, ActionsCellRendererValue>,
    ): void {
        this.data = params.data;
        this.defaultCallback = params.value?.defaultCallback;
        this.actions$ = params.value?.actions$;
    }

    public refresh(
        params: ICellRendererParams<any, ActionsCellRendererValue>,
    ): boolean {
        this.agInit(params);
        return true;
    }

    public actionClicked(action: ActionRendererAction, data: any) {
        if (action.callback) {
            action.callback(data);
            return;
        }
        this.defaultCallback?.(action, data);
    }

    public openChange(opened: boolean) {
        this.opened = opened;
    }
}
